import React, {
  useMemo,
} from 'react';
import {
  MessageInputContextProvider,
  useMessageInputContext,
} from 'stream-chat-react';
import { useEmojiTrigger } from 'stream-chat-react/dist/components/MessageInput/hooks/useEmojiTrigger';
import { useUserTrigger } from 'stream-chat-react/dist/components/MessageInput/hooks/useUserTrigger';

import PropTypes from 'prop-types';

const CustomTriggerProvider = ({ children }) => {
  const currentContextValue = useMessageInputContext();
  const emojiTrigger = useEmojiTrigger(currentContextValue.emojiIndex);
  const userTrigger = useUserTrigger({
    disableMentions: currentContextValue.disableMentions,
    mentionAllAppUsers: currentContextValue.mentionAllAppUsers,
    mentionQueryParams: currentContextValue.mentionQueryParams,
    onSelectUser: currentContextValue.onSelectUser,
  });

  const customTriggers = useMemo(() => ({
    ':': emojiTrigger,
    '@': userTrigger,
  }), [
    emojiTrigger,
    userTrigger,
  ]);

  const updatedContextValue = useMemo(() => ({
    ...currentContextValue,
    autocompleteTriggers: customTriggers,
    grow: true,
    maxRows: 15,
  }), [
    currentContextValue,
    customTriggers,
  ]);

  return (
    <MessageInputContextProvider value={updatedContextValue}>
      {children}
    </MessageInputContextProvider>
  );
};

CustomTriggerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomTriggerProvider;
